import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";
import type { ParamsType } from "./types";
import * as ac from "./actionCreators";

const initialState = {
    defaultUrl: "",
    parent: "",
    appId: "",
    category: "",
    categoryMode: "",
    changedDuration: undefined,
    country: "",
    duration: "",
    mode: "",
};

const urlParamsReducer = createReducer<ParamsType, ActionType<typeof ac>>(initialState)
    .handleAction(
        ac.setUrlParams,
        (state, { payload }): ParamsType => ({
            ...state,
            ...payload,
        }),
    )
    .handleAction(
        ac.resetUrlParams,
        (): ParamsType => ({
            ...initialState,
        }),
    );

export default urlParamsReducer;
